import 'moment/locale/en-gb';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-hk';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'styles/global.scss';
import App from './App';
import './i18n'; // Initialize i18next

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// For embedding into other sites
window.StAndrewsGivingPlatform = {
  mount: (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      const root = ReactDOM.createRoot(element);
      root.render(<App />);
      return root;
    }
    console.error(`Element with id "${elementId}" not found`);
    return null;
  },
  unmount: (root) => {
    if (root) {
      root.unmount();
    }
  }
};
